import React, { ComponentType, FC } from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router";
import { ROUTE_APP_EMPTY } from "../../../constants/routes/app";
import { useChannel } from "../../../libs/channels/hooks/use-channel";
import { RootState } from "../../../redux/reducers";

type PrivateRouteProps = {
    path: string;
    component: ComponentType;
};

export const PrivateRoute: FC<PrivateRouteProps> = ({
    path,
    component,
}: PrivateRouteProps) => {
    const isStartedFlow = useSelector<RootState>(
        (state) => state.page.isStartedFlow
    );
    const { normalizedPathname } = useChannel();
    if (
        !isStartedFlow &&
        path !== ROUTE_APP_EMPTY &&
        normalizedPathname !== ROUTE_APP_EMPTY
    ) {
        return <Redirect to={ROUTE_APP_EMPTY} />;
    }
    return <Route path={path} component={component}></Route>;
};
